import { createAction } from 'redux-actions';

export const setDomain = createAction('SET_DOMAIN');